import script from "./Klv3Simple.vue?vue&type=script&setup=true&lang=js"
export * from "./Klv3Simple.vue?vue&type=script&setup=true&lang=js"

import "./Klv3Simple.vue?vue&type=style&index=0&id=2600f8fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2600f8fe"]])

export default __exports__